import React from "react";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { inject, observer } from "mobx-react";
import { isMobile } from "react-device-detect";

const DRAWER_WIDTH = 210;

/**
 * Fixed "add" button pinned to the bottom-center of the content area.
 * Accounts for the 210px left drawer when it is open.
 */
const FabAdd = ({ onClick, Auth }) => {
  const drawerOpen = Auth?.menuVisible && !isMobile;
  const left = drawerOpen
    ? `calc(50% + ${DRAWER_WIDTH / 2}px)`
    : "50%";

  return (
    <>
      <div style={{ height: 88 }} />
      <Fab
        color="secondary"
        onClick={onClick}
        sx={{
          position: "fixed",
          bottom: 24,
          left,
          transform: "translateX(-50%)",
          transition: "left 218ms cubic-bezier(0.4, 0.2, 0.2, 1)",
          zIndex: 1200,
        }}
      >
        <AddIcon />
      </Fab>
    </>
  );
};

export default inject("Auth")(observer(FabAdd));
